import { Box, BoxProps } from "@chakra-ui/react";

export function HomeIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 14 14"
        stroke="none"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.75 12.8332V5.46135C0.75 5.22288 0.803333 4.99697 0.91 4.78364C1.01681 4.57017 1.16431 4.3944 1.3525 4.25635L6.09625 0.682598C6.35944 0.481765 6.66028 0.381348 6.99875 0.381348C7.33722 0.381348 7.63889 0.481765 7.90375 0.682598L12.6475 4.25635C12.8357 4.3944 12.9832 4.57017 13.09 4.78364C13.1967 4.99697 13.25 5.22288 13.25 5.46135V12.8332C13.25 13.1741 13.1269 13.4676 12.8806 13.7138C12.6344 13.9601 12.3408 14.0832 12 14.0832H9.33979C9.12632 14.0832 8.94743 14.011 8.80313 13.8666C8.65868 13.7223 8.58646 13.5434 8.58646 13.3299V9.25947C8.58646 9.04614 8.51431 8.86725 8.37 8.72281C8.22569 8.5785 8.04681 8.50635 7.83333 8.50635H6.16667C5.95319 8.50635 5.77431 8.5785 5.63 8.72281C5.48569 8.86725 5.41354 9.04614 5.41354 9.25947V13.3299C5.41354 13.5434 5.34132 13.7223 5.19688 13.8666C5.05257 14.011 4.87368 14.0832 4.66021 14.0832H2C1.65917 14.0832 1.36562 13.9601 1.11937 13.7138C0.873125 13.4676 0.75 13.1741 0.75 12.8332Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  );
}
